import { Avatar } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { getComments } from "../../redux/actions/comAction";
import { reset } from "../../redux/actions/initAction";
import {
  createPost,
  getPostDetails,
  uGetPosts,
  updatePost,
} from "../../redux/actions/postAction";
import { getTags } from "../../redux/actions/tagAction";
import "../../styles/createPost.scss";
import getOneImageFromSections from "../../utils/getFeturedImageForPosts";
import { sortBySections } from "../../utils/sortPostBySections";
import Comment from "../mega/Comment";
import CommentBox from "../mini/CommentBox";
import FloatIcons from "../mini/FloatIcons";
import CustomLink from "../mini/Link";
import Loader from "../mini/Loader";
import MiniArticle from "../mini/MiniArticle";
import Power from "../../shared/Power/Power";
import MetaTags from "react-meta-tags";
import { followBlog, unfollowBlog } from "../../redux/actions/blogAction";
import ConfirmModal from "../mega/ConfirmModal";
import BackIcon from "@material-ui/icons/KeyboardBackspaceOutlined";
import ViewPostDesktop from "../ViewPost/ViewPostDesktop";
import { useQuery } from "@tanstack/react-query";
import { getPostsBySlugAPI } from "../../api/GetPosts";
import { useAuthStore } from "../../store/AuthStore";
import { useParams, useHistory } from "react-router-dom";
import dayjs from "dayjs";

const ViewPost = (props) => {
  const ref = useRef(null);
  const history = useHistory();
  const { slugId } = useParams();
  const { userData, isLoggedIn } = useAuthStore();

  const [title, setTitle] = useState("");

  const [postImage, setPostImage] = useState({
    url: "",
    alt: "",
  });

  const [sectionData, setSectionData] = useState("");

  const [comCount, setComCount] = useState(2);
  const [moreFrom, setMoreFrom] = useState();
  const [related, setRelated] = useState();
  const [following, setFollowing] = useState(false);
  const [letThereBeLight, setLetThereBeLight] = useState(false);

  const { isLoading, data: currentPost } = useQuery({
    queryKey: ["GetPostBySlug", slugId],
    queryFn: () => getPostsBySlugAPI(slugId),
    select: ({ data }) => data.data,
  });

  // TODO: use this when comment section is remade
  // const { data: commentData, refetch } = useQuery({
  //   queryKey: ["GetPostComments", comCount],
  //   queryFn: () =>
  //     getCommentsAPI({
  //       size: 3,
  //       page: 1,
  //       postId: currentPost.id,
  //     }),
  //   select: ({ data }) => data.data,
  //   enabled: currentPost?.id ? true : false,
  // });

  useEffect(() => {
    if (currentPost?.id) {
      props.getComments(comCount, 1, currentPost?.id);
    }
  }, [comCount, currentPost]);

  useEffect(() => {
    if (currentPost) {
      // const { tags } = currentPost;
      const sections = sortBySections(currentPost);

      setTitle(currentPost.title);

      sections.forEach((section) => {
        if (section.type === "picture") {
          setPostImage({
            url: section.value,
            alt: section.label,
          });
        }

        if (section.type === "text") {
          setSectionData(section.value);
        }
      });

      // 'More from' posts...
      uGetPosts({
        size: 6,
        page: 1,
        category: "popular",
        blogId: currentPost.blog?.id,
      }).then((res) => {
        if (res?.posts) {
          const t = filterCurrentPost(res.posts);
          setMoreFrom(t.slice(0, 5) || null);
        }
      });
    }
  }, [currentPost]);

  const filterCurrentPost = (postsArr) => {
    const { id: currentId } = currentPost;
    return postsArr?.filter((post) => post.id !== currentId) || postsArr;
  };

  const primaryBtnAction = () => {
    if (following) {
      props.unfollowBlog(currentPost.blogId).then((rs) => {
        setFollowing(false);
      });
    } else {
      props.followBlog(currentPost.blogId).then((rs) => {
        setFollowing(true);
      });
    }
  };

  const searchByTag = (e, tag_name) => {
    e.stopPropagation();
    history.push(`/search/1/posts/${tag_name}`);
  };

  useEffect(() => {
    if (currentPost) {
      setFollowing(currentPost.isBlogFollowed);
    }
  }, [currentPost]);

  const handleGoToComment = () => {
    ref.current.scrollIntoView({ behavior: "smooth" });
  };

  const handleReadMore = () => {
    setLetThereBeLight(!letThereBeLight);
  };

  return (
    <>
      {isLoading ? (
        <Loader style={{ height: "80vh" }} />
      ) : currentPost ? (
        <>
          <MetaTags>
            <title>{title}</title>
            <meta name="description" content={currentPost.blog.description} />
            <meta property="og:title" content={currentPost.blog.title} />
            <meta property="og:image" content={currentPost.imageUrl} />
          </MetaTags>

          <div className="create-post-container">
            <ViewPostDesktop
              title={title}
              post={currentPost}
              searchByTag={searchByTag}
              postData={sectionData}
              postImage={postImage}
              following={following}
              primaryBtnAction={primaryBtnAction}
              setComCount={setComCount}
              comCount={comCount}
              commentCount={props.commentCount}
              comments={props.comments}
              moreFrom={moreFrom}
              related={related}
              getComments={() => props.getComments(comCount, 1, props.post?.id)}
            />

            {/* MOBILE */}
            <div className="mobile-container">
              <div className="header">
                <div>&nbsp;</div>
                <div className="back" onClick={() => history.goBack()}>
                  <BackIcon /> Back
                </div>
                <div className="title">
                  <h1>{title}</h1>
                </div>
                {currentPost.tags?.length <= 3 ? (
                  <div className="tags">
                    {currentPost.tags?.map((tag) => (
                      <div
                        key={tag.id}
                        className="custom-tag"
                        onClick={(e) => searchByTag(e, tag.name.toLowerCase())}
                      >
                        #{tag.name}
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="tags">
                    {currentPost.tags?.slice(0, 3).map((tag) => (
                      <div
                        key={tag.id}
                        className="custom-tag"
                        onClick={(e) => searchByTag(e, tag.name.toLowerCase())}
                      >
                        #{tag.name}
                      </div>
                    ))}
                    <div
                      className="custom-tag"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleReadMore();
                      }}
                    >
                      {letThereBeLight
                        ? "less"
                        : `+${currentPost.tags?.length - 3}`}
                    </div>
                    {letThereBeLight && (
                      <div className="tags">
                        {currentPost.tags?.slice(3).map((tag) => (
                          <div
                            key={tag.id}
                            className="custom-tag"
                            onClick={(e) =>
                              searchByTag(e, tag.name.toLowerCase())
                            }
                          >
                            #{tag.name}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}

                <div className="author">
                  <Avatar src={currentPost.blog?.author?.profileImage}>
                    {currentPost.blog?.author?.firstName[0]}
                    {currentPost.blog?.author?.lastName[0]}
                  </Avatar>
                  <div className="author-info">
                    <p>
                      by{" "}
                      <span
                        onClick={() =>
                          props.history.push(
                            `/blogfolio/${currentPost.blog?.urlSlug}/about`
                          )
                        }
                      >
                        Dr. {currentPost.blog?.author?.firstName}{" "}
                        {currentPost.blog?.author?.lastName ?? ""}
                      </span>{" "}
                      in{" "}
                      <span
                        className="cursor-pointer"
                        onClick={() =>
                          props.history.push(
                            `/blogfolio/${currentPost.blog?.urlSlug}/posts`
                          )
                        }
                      >
                        {currentPost.blog?.title}
                      </span>
                    </p>
                    <p>
                      {dayjs(currentPost.updatedAt).format("DD MMM YYYY")}{" "}
                      (edited)
                    </p>
                  </div>
                </div>
                <div className="bar">
                  <Power count={currentPost.powerScore} isViewPost={true} />
                  <FloatIcons
                    post={currentPost}
                    handleGoToComment={handleGoToComment}
                  />
                </div>
              </div>

              <div
                className="max-w-screen-xl mob-view"
                style={{ flexWrap: "wrap", padding: "0 15px" }}
              >
                {/* Post Image */}
                <div className="viewpostImageWrapper">
                  <div className="imgWrapper">
                    <img src={postImage.url} alt={postImage.alt} />
                  </div>
                  <div className="captionWrapper">
                    <p className="caption">{postImage.alt}</p>
                  </div>
                </div>

                {/* Post Data */}
                <div
                  className="viewpostDataWrapper"
                  dangerouslySetInnerHTML={{ __html: sectionData }}
                />

                <h1 className="comment-head" ref={ref}>
                  {props.commentCount} Comments
                </h1>
                <hr className="line" />
                {isLoggedIn && (
                  <CommentBox
                    callChild={() => setComCount(comCount + 2)}
                    postId={currentPost.id}
                    refetch={() =>
                      props.getComments(comCount, 1, props.post?.id)
                    }
                  />
                )}
                <hr className="line mb-3" />
                {props.comments?.map((comment) => (
                  <div key={comment.id}>
                    <Comment
                      callSelf={() => setComCount(comCount + 2)}
                      comment={comment}
                    />
                    <hr className="line my-8" />
                  </div>
                ))}
                {props.commentCount > props.comments?.length && (
                  <p onClick={() => setComCount(comCount + 2)} className="load">
                    LOAD MORE COMMENTS
                  </p>
                )}

                {currentPost.blog?.author && (
                  <div className="author-view-container mb-4">
                    <div
                      className="flex mob-block mb-3"
                      style={{
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div
                        className="flex"
                        style={{
                          alignItems: "center",
                        }}
                      >
                        <Avatar
                          className="mr-3"
                          size={80}
                          src={currentPost.blog?.author?.profileImage}
                        >
                          {currentPost.blog?.author?.firstName
                            ? currentPost.blog?.author?.firstName[0]
                            : ""}
                          {currentPost.blog?.author?.lastName
                            ? currentPost.blog?.author?.lastName[0]
                            : ""}
                        </Avatar>
                        <div>
                          <p style={{ fontSize: "14px" }}>About the Author</p>
                          <p style={{ fontSize: "16px", fontWeight: "bold" }}>
                            Dr.{" "}
                            {`${currentPost.blog?.author?.firstName} ${
                              currentPost.blog?.author?.lastName
                                ? currentPost.blog?.author?.lastName
                                : ""
                            }`}
                          </p>
                        </div>
                      </div>
                      {isLoggedIn && (
                        <div>
                          <div className="mt-3 flex mob-block text-center justify-end items-end">
                            <button
                              onClick={() => {
                                props.history.push(
                                  `/blogfolio/${currentPost.blog?.urlSlug}/about`
                                );
                              }}
                              style={{ lineHeight: 1.3 }}
                              className={`w-100 font-bold rounded-full text-sm btn-custom-sm bg-700-border white-button-bg-700-border
                          }`}
                            >
                              VIEW BLOG
                            </button>

                            {userData.id !== currentPost.blog?.author?.id &&
                              isLoggedIn &&
                              (following ? (
                                <button
                                  style={{ lineHeight: 1.3 }}
                                  className={
                                    "w-100 mt-2 font-bold rounded-full text-sm btn-custom-sm bg-700-border bg-blue-700 text-white"
                                  }
                                >
                                  <ConfirmModal
                                    title="Are you sure you want to unfollow?"
                                    btnName="UNFOLLOW BLOG"
                                    onOk={() => {
                                      primaryBtnAction();
                                    }}
                                  />
                                </button>
                              ) : (
                                <button
                                  onClick={primaryBtnAction}
                                  style={{ lineHeight: 1.3 }}
                                  className={
                                    "w-100 mt-2 font-bold rounded-full text-sm btn-custom-sm bg-700-border bg-blue-700 text-white"
                                  }
                                >
                                  FOLLOW BLOG
                                </button>
                              ))}
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="pb-4 text-break">
                      <p>{currentPost.blog?.description}</p>
                    </div>
                  </div>
                )}
                <div
                  style={{
                    padding: "0 14px",
                  }}
                >
                  {currentPost.blog && moreFrom?.length > 0 && (
                    <>
                      <h2 className="mb-4">
                        More From {currentPost.blog?.title}
                      </h2>
                      <div className="flex flex-col gap-4">
                        {moreFrom.map((post) => (
                          <MiniArticle
                            key={currentPost.id}
                            history={props.history}
                            slug={currentPost.urlSlug}
                            title={currentPost.title}
                            imageUrl={
                              currentPost.imageUrl ||
                              getOneImageFromSections(currentPost.sections)
                            }
                          />
                        ))}
                      </div>
                      <div className="text-right">
                        <CustomLink
                          to={`/blogfolio/${currentPost.blog?.urlSlug}/posts`}
                          type="viewAll"
                        >
                          VIEW ALL
                        </CustomLink>
                      </div>
                    </>
                  )}
                  {related && !!related?.length && (
                    <>
                      <h2 className="mt-10 mb-4">Related Articles</h2>
                      <div className="flex flex-col gap-4">
                        {related?.map((post) => (
                          <MiniArticle
                            key={post.id}
                            history={props.history}
                            slug={post.urlSlug}
                            title={post.title}
                            imageUrl={
                              post.imageUrl ||
                              getOneImageFromSections(post.sections)
                            }
                          />
                        ))}
                        <div className="text-right">
                          {currentPost.tags?.length > 0 && (
                            <CustomLink
                              to={`/search/posts?tags=${encodeURIComponent(
                                "#" + currentPost.tags[0].name
                              )}`}
                              type="viewAll"
                            >
                              {" "}
                              VIEW ALL{" "}
                            </CustomLink>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div
          style={{
            marginTop: "20px",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "40px",
            fontWeight: 700,
            color: "#0F1734",
            height: "50vh",
          }}
        >
          404
          <p
            style={{
              fontSize: "24px",
              fontWeight: 700,
              color: "#0F1734",
            }}
          >
            Sorry, the post you requested could not be found.
          </p>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  tags: state.tag.tags,
  post: state.post.post,
  comments: state.com.comments,
  commentCount: state.com.commentCount,
  hideCom: state.com.hideCom,
});

export default connect(mapStateToProps, {
  getTags,
  createPost,
  updatePost,
  getPostDetails,
  reset,
  getComments,
  followBlog,
  unfollowBlog,
})(ViewPost);
